// Shared Meta (Facebook) Pixel ID validation, used by both the LP Express
// settings UI (client-side mirror) and the server-side save route (the
// authoritative check). Meta Pixel IDs are numeric; today they're typically
// 15–16 digits, but we accept 10–20 so a future Meta format shift doesn't
// reject valid IDs. Always trim before validating.
export const META_PIXEL_ID_RE = /^\d{10,20}$/;

export const META_PIXEL_ID_ERROR =
  "Pixel ID must be 10–20 digits (numbers only). Find your Pixel ID in Meta Events Manager.";

export function isValidMetaPixelId(id: string): boolean {
  return META_PIXEL_ID_RE.test(id);
}
